import React, { useState,useEffect } from 'react';
import './Nav.css'



function Nav() {

    const [show,handleShow] =useState(false);

    useEffect(() => {
        window.addEventListener("scroll",()=>{
            if(window.scrollY>100){
                handleShow(true);
            }else handleShow(false);
        })
    });


    return(
        <div className={`nav ${show && "nav__black"}`}>
            <img
                className="nav__logo"
                src="https://assets.stickpng.com/images/580b57fcd9996e24bc43c529.png"
                alt="Netflix Logo"
            />
            <img
                className="nav__avatar"
                src="https://lh3.googleusercontent.com/ogw/ADGmqu_RVZF-rmDpx3yLKk8QTZ0zti0v0cgLpOy_BWRj=s83-c-mo"
                alt="Netflix Avatar"
            />

        </div>
    )
}

export default Nav;